import React, { useEffect, useState } from 'react';
import styles from '../../../../styles/modules/RegistrationSetup.module.css';
import { MdDelete, MdDragIndicator, MdOutlineModeEditOutline } from "react-icons/md";
import CustomSwitch from '../../../CustomComponents/CustomSwitch/CustomSwitch';
import { Accordion, AccordionDetails, AccordionSummary, Button, Dialog, DialogContent, DialogContentText, DialogTitle, FormControl, FormHelperText, IconButton, InputLabel, Menu, MenuItem, Select, Slide, TextField, Typography } from '@mui/material';
import { GrAdd, GrFormAdd } from 'react-icons/gr';
import { inputTypeList } from '../helper';
import { CgClose } from "react-icons/cg";
import { FormTemplateAPI } from '../../../../api/FormTemplateAPI';
import { useSelector } from 'react-redux';
import { IoIosArrowDropdownCircle } from "react-icons/io";
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import Loader from '../../../../component/Loader.jsx';
import deleteAreaImg from '../../../../assets/images/trash.png'
import CustomAlertDialog from '../../../CustomComponents/CustomAlertDialog.jsx';
import { CiMenuKebab } from "react-icons/ci";
import { AiTwotoneDelete } from "react-icons/ai";
import { rootAction } from '../../../../redux/reducer/rootReducer.js';
import { useDispatch } from 'react-redux';
import CustomDialog from '../../../CustomComponents/CustomDialog/CustomDialog.jsx';
import { Privileges } from '../../../../util/PrivilegeConstants.js';
import * as Yup from 'yup';
import CustomCheckbox from '../../../CustomComponents/CustomCheckbox/CustomCheckbox.jsx';

const initialValue = {
  section: '',
  fieldType: '',
  tooltip: '',
  isRequired: false,
  fieldName: '',
  bindWith: ''
}

const validationObj = Yup.object({
  section: Yup.string().required("Section is required"),
  fieldType: Yup.string().required("Field type is required"),
  fieldName: Yup.string().required("Field Name is required").max(100, "Field name must not exceed 100 characters."),
});

const PREDEFINED_FIELDS = [
  { label: "Mobile Number", key: "mobile_number" },
  { label: "Email", key: "email" },
  { label: "Club Name", key: "club_name" }
];


const FormFields = ({ formTemplateId, privileges, formtemplateStatus }) => {
  const selectedClub = useSelector((store) => store.user.selectedClub);
  const userInfo = useSelector((store) => store.user.userInfo);
  const [openPopup, setOpenPopup] = useState({ isOpen: false, for: '', isEdit: false });
  const [fieldData, setFieldData] = useState(initialValue);
  const [options, setOptions] = useState([''])
  const [formSections, setFormSections] = useState([]);
  const [formFieldsWithSection, setFormFieldsWithSection] = useState([])
  const [formFields, setFormFields] = useState([]);
  const [formSection, setFormSection] = useState({ id: '', name: '' });
  const [isUpdate, setIsUpdate] = useState(false);
  const [isAddSection, setIsAddSection] = useState(false);
  const [openAlert, setOpenAlert] = useState({ isAlert: false, id: '', isField: false });
  const [loadingState, setLoadingState] = useState({
    loading1: false,
    loading2: false
  });
  const [fieldErrors, setFieldErrors] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const dispatch = useDispatch();
  const [openSectionMenu, setOpenSectionMenu] = useState(null);

  const startLoaoding = (key) => {
    setLoadingState((prev) => ({
      ...prev, [key]: true
    }))
  };
  const finishLoaoding = (key) => {
    setLoadingState((prev) => ({
      ...prev, [key]: false
    }))
  };

  const handleSetData = (e) => {
    const { name, value } = e.target;
    setFieldData({ ...fieldData, [name]: value });

  }
  const handleFieldOptions = (val, index) => {
    setOptions((prev) => {
      let newData = [...prev];
      newData[index] = val;
      return newData;
    })

  }
  const handleIsShowField = (val, id, sectionId) => {
    setFormFields((prev) => {
      const sectionFields = prev[sectionId] || [];
      const updatedFields = sectionFields.map((field) =>
        field.id === id ? { ...field, isShow: val } : field
      );
      return {
        ...prev,
        [sectionId]: updatedFields,
      };
    });
  };

  const onSubmitForm = async () => {
    try {
      await validationObj.validate(fieldData, { abortEarly: false });
      const fieldName = fieldData?.fieldName?.replaceAll(" ", "_").toLowerCase();
      const isDuplicate = formFieldsWithSection.some(section =>
        section.formFields.some(f => (f.name.replaceAll(" ", "_").toLowerCase() === fieldName && section.sectionId === fieldData.section) && !openPopup.isEdit)
      );
      if (isDuplicate) {
        dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'error', content: 'Field already exist' }));
        return;
      }
      startLoaoding('loading1')
      if (openPopup.isEdit) {
        await FormTemplateAPI.putUpdateFormField({
          id: fieldData.id,
          name: fieldData.fieldName,
          type: fieldData.fieldType,
          metadata: JSON.stringify({
            tooltip: fieldData.tooltip,
            options: options,
            bindWith: fieldData.bindWith
          }),
          isRequired: fieldData.isRequired
        });
      } else {
        await FormTemplateAPI.postAddFormField({
          name: fieldData.fieldName,
          type: fieldData.fieldType,
          orderIndex: formFields[fieldData.section].length,
          metadata: JSON.stringify({
            tooltip: fieldData.tooltip,
            options: options,
            bindWith: fieldData.bindWith
          }),
          isRequired: fieldData.isRequired,
          templateId: formTemplateId,
          sectionId: fieldData.section,
        });
      }
      setIsUpdate(true)
      setOpenPopup({ isOpen: false, for: openPopup.for, isEdit: false });
      setFieldData({});
      setFieldErrors({});
    } catch (error) {
      console.log(error);
      if (error?.inner) {
        let errorObj = {}
        error.inner.forEach(err => {
          errorObj[err.path] = err.message;
        })
        setFieldErrors(errorObj)
      }
    } finally {
      finishLoaoding('loading1')
    }
  }

  const handleFormSectionSubmit = async () => {
    try {
      if (!formSection.name) {
        setFieldErrors({ sectionName: 'Section Name id required' });
        return;
      }
      startLoaoding('loading1')
      if (openPopup.isEdit) {
        await FormTemplateAPI.putUpdateFormSection({
          id: formSection.id,
          clubId: selectedClub.clubId,
          title: formSection.name
        })
      } else {
        await FormTemplateAPI.postAddFormSection({
          templateId: formTemplateId,
          clubId: selectedClub.clubId,
          title: formSection.name,
          orderIndex: formFieldsWithSection.length + 1
        })
      }

      setIsAddSection(true);
      setOpenPopup({ isOpen: false, for: openPopup.for, isEdit: false });
      setFormSection({ id: '', name: '' });
      setFieldErrors({})
    } catch (error) {
      console.log(error);
    } finally {
      finishLoaoding('loading1')
    }
  };

  const getAllFormSection = async () => {
    try {
      startLoaoding('loading1')
      const response = await FormTemplateAPI.getAllFormSection(selectedClub.clubId, formTemplateId);
      setFormSections(response.Data)
    } catch (error) {
      console.log(error);
    } finally {
      finishLoaoding('loading1')
    }
  };
  const getAllFormFieldsWithSection = async () => {
    try {
      startLoaoding('loading2')
      const response = await FormTemplateAPI.getAllFormFieldsWithSection(selectedClub.clubId, formTemplateId);
      setFormFieldsWithSection(response.Data);

      response.Data.forEach((s) => {
        setFormFields((prev) => ({
          ...prev,
          [s.sectionId]: s.formFields,
        }));
      });
    } catch (error) {
      console.log(error);
    } finally {
      finishLoaoding('loading2')
    }
  };
  useEffect(() => {
    getAllFormSection();
    isAddSection && setIsAddSection(false);
  }, [isAddSection])
  useEffect(() => {
    if (selectedClub.clubId) {
      getAllFormFieldsWithSection();
    }
    isUpdate && setIsUpdate(false);
    isAddSection && setIsAddSection(false);
  }, [isUpdate, isAddSection, selectedClub.clubId])

  function swapElements(array, index1, index2) {
    if (
      !Array.isArray(array) ||
      index1 < 0 || index1 >= array.length ||
      index2 < 0 || index2 >= array.length
    ) {
      throw new Error("Invalid input: Check if array is valid and indexes are in range.");
    }

    const newArray = [...array]; // Create a copy to avoid mutating the original
    const temp = newArray[index1];
    newArray[index1] = newArray[index2];
    newArray[index2] = temp;

    return newArray;
  }
  const isRequiredSection = (id) => {
    const section = formFieldsWithSection.find(item => item.sectionId === id);
    const fields = section?.formFields ?? [];
    return fields.some(item => !item.isRemovable);
  };

  const onDragStop = (args) => {
    const { source, destination, type, draggableId } = args;
    if (!destination) return;
    if (type === 'FIELD' && destination.droppableId === source.droppableId) {
      setFormFields((prev) => {
        const newFields = Array.from(prev[source.droppableId]);
        const [moved] = newFields.splice(source.index, 1);
        newFields.splice(destination.index, 0, moved);
        return {
          ...prev,
          [source.droppableId]: newFields,
        };
      });
    }
    if (type === 'SECTION' && destination.droppableId === source.droppableId) {
      const newList = swapElements(formFieldsWithSection, source.index, destination.index);
      setFormFieldsWithSection(newList);
      updateFormSectionOrderIndex(newList.map((item, index) => ({ sectionId: item.sectionId, index: index })))
    }
    if (type === 'SECTION' && destination.droppableId === "main_field_delete_list1") {
      setOpenAlert({ isAlert: true, id: draggableId, isField: false });
    }
    if (type === 'FIELD' && destination.droppableId === "main_field_delete_list2") {
      setOpenAlert({ isAlert: true, id: draggableId, isField: true });
    }


  };
  const onDragStart = (args) => {
    const { source, type } = args;
    if (!privileges?.MANAGE_FORM_FIELD?.includes(Privileges.DELETE)) {
      return;
    }
  };
  const updateFormFieldOrderIndex = async (sectionId) => {
    try {
      if (formFields[sectionId].length == 0) return;
      const reqData = formFields[sectionId].map((item, index) => ({ id: item.id, index: index }))
      await FormTemplateAPI.putUpdateFormFieldIndex(reqData);
    } catch (error) {
      console.log(error);
    }
  };
  const updateIsShowField = async (isShowData) => {
    try {
      await FormTemplateAPI.putUpdateFormFieldIsShow(isShowData)
      dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'success', content: 'Form field updated successfully' }));
    } catch (error) {
      console.log(error);
    }
  };
  const onSaveButtonClick = async (sectionId) => {
    try {
      updateFormFieldOrderIndex(sectionId);
      const isShowData = formFields[sectionId].map((item) => ({ id: item.id, isShow: item.isShow, sectionId: sectionId }));
      updateIsShowField(isShowData);
      setIsUpdate(true);
    } catch (error) {
      console.log(error);
    }
  };
  const updateFormSectionOrderIndex = async (newList) => {
    try {
      await FormTemplateAPI.putUpdateFormSectionOrderIndex(newList);
    } catch (error) {
      console.log(error);
    }
  };

  const deleteSection = async (id) => {
    try {
      await FormTemplateAPI.deleteFormSection({
        clubId: selectedClub.clubId,
        sectionId: id,
        formTemplateId: formTemplateId
      });
      setIsUpdate(true)
      setIsAddSection(true);
      setOpenAlert({ isAlert: false, id: '', isField: false });
    } catch (error) {
      console.log(error);
    }
  };
  const deleteField = async (id) => {
    try {
      await FormTemplateAPI.deleteFormField(selectedClub.clubId, id);
      setIsUpdate(true)
      setOpenAlert({ isAlert: false, id: '', isField: false });
      setFieldData(initialValue);
    } catch (error) {
      console.log(error);
    }
  };
  const handleEditFormField = () => {
    setOpenPopup({ isOpen: true, for: 'FIELD', isEdit: true })
  };
  const handleActionMenuOpen = (event, id, sectionId, type, name, metadata, isRequired) => {
    setFieldData({
      id: id,
      section: sectionId,
      fieldName: name,
      fieldType: type,
      isRequired: isRequired,
      tooltip: metadata.tooltip,
    })
    setOptions(metadata.options)
    setAnchorEl(event.currentTarget);
  };
  const handleActionMenuClose = () => {
    setAnchorEl(null);
  };



  return (
    <div className={styles['cus_form_fields_container']}>
      {(loadingState.loading1 || loadingState.loading2) && <Loader />}

      <div className={styles['add_cus_field_container']}>
        <h2 className={styles['form_overview_heading']}>Form Fields</h2>
        {(privileges?.MANAGE_FORM_FIELD?.includes(Privileges.CREATE) && formtemplateStatus === 'IN_PROGRESS') &&
          <div className={styles['add_cus_field_btn']}>
            <button onClick={() => setOpenPopup({ isOpen: true, for: 'SECTION', isEdit: false })} ><GrAdd />Add New Section</button>
            <button onClick={() => setOpenPopup({ isOpen: true, for: 'FIELD', isEdit: false })} ><GrAdd />Add New Field</button>
          </div>}
      </div>
      <div className={styles['cus_form_fields_heading']}>
        <div className={styles['part_1']}></div>
        <div className={styles['part_2']}>Custom Field</div>
        <div className={styles['part_3']}>Type</div>
        <div className={styles['part_4']}>Show</div>
        <div className={styles['part_5']}>Action</div>
      </div>
      <DragDropContext onDragEnd={onDragStop} onDragStart={onDragStart}>

        <Droppable droppableId='main_field_list' type='SECTION' >
          {(provided1) => (
            <div className={styles['cus_form_fields_section_con']} ref={provided1.innerRef} {...provided1.droppableProps}>
              {formFieldsWithSection?.map((section, index) =>

                <Draggable isDragDisabled={!privileges?.MANAGE_FORM_FIELD?.includes(Privileges.MODIFY) || formtemplateStatus !== 'IN_PROGRESS'} draggableId={section.sectionId} index={index} key={section.sectionId}>
                  {(provided1) => (
                    <Accordion
                      ref={provided1.innerRef} {...provided1.draggableProps} {...provided1.dragHandleProps}
                      key={section.sectionId}

                      sx={{
                        borderRadius: '10px',
                        '&::before': {
                          display: 'none',
                        },
                        '&:last-of-type': {
                          borderRadius: '10px',
                        },
                        '&:first-of-type': {
                          borderRadius: '10px',
                        },
                        boxShadow: "rgba(0, 0, 0, 0.16) 0px 10px 36px 0px,rgba(0, 0, 0, 0.06) 0px 0px 0px 1px"
                      }}>
                      <AccordionSummary
                        expandIcon={<IoIosArrowDropdownCircle className={styles['cus_form_expand_icon']} />}
                        aria-controls="panel1-content"
                        id="panel1-header"
                      >
                        <Typography sx={{ fontWeight: 500, fontSize: 20, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1, width: '100%' }} component="span">
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <MdDragIndicator className={styles['cus_form_fields_drag_icon']} />
                            {section?.sectionName}
                          </div>
                          {(formtemplateStatus === 'IN_PROGRESS' && privileges?.MANAGE_FORM_FIELD?.includes(Privileges.MODIFY)) &&
                            <IconButton onClick={(e) => {
                              e.stopPropagation();
                              setFormSection({ id: section.sectionId, name: section.sectionName });
                              setOpenSectionMenu(e.currentTarget);
                            }}>
                              <CiMenuKebab className={styles['cus_form_expand_icon_delete']} />
                            </IconButton>}
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Droppable droppableId={section.sectionId} type='FIELD'>
                          {
                            (provided) => (
                              <ul key={index} className={styles['cus_form_fields_list']} ref={provided.innerRef} {...provided.droppableProps} >
                                {
                                  formFields[section.sectionId]?.map((field, index) =>
                                    <Draggable isDragDisabled={!privileges?.MANAGE_FORM_FIELD?.includes(Privileges.MODIFY) || formtemplateStatus !== 'IN_PROGRESS'} draggableId={field.id} index={index} key={field.id}>
                                      {
                                        (provided) => (
                                          <li ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} className={styles['cus_form_fields_item']} draggable={true}>
                                            <div className={styles['part_1']}> <MdDragIndicator className={styles['cus_form_fields_drag_icon']} /></div>
                                            <div className={styles['part_2']}>{field.name}</div>
                                            <div className={styles['part_3']}>{field.type}</div>


                                            <div className={styles['part_4']}>
                                              <CustomSwitch
                                                isDisable={!field?.isRemovable}
                                                checked={field.isShow}
                                                onChange={(e) => handleIsShowField(e.target.checked, field.id, section.sectionId)}
                                              />
                                            </div>

                                            {field?.isRemovable &&
                                              <div className={styles['part_5']}>
                                                {(formtemplateStatus === 'IN_PROGRESS' && privileges?.MANAGE_FORM_FIELD?.includes(Privileges.MODIFY)) &&
                                                  <CiMenuKebab
                                                    style={{ cursor: 'pointer', fontSize: '1.5rem' }}
                                                    onClick={(event) => handleActionMenuOpen(event, field.id, section.sectionId, field.type, field.name, JSON.parse(field.metadata), field.isRequired)} />}
                                              </div>}
                                            {provided.placeholder}
                                          </li>
                                        )
                                      }
                                    </Draggable>
                                  )
                                }
                                {provided.placeholder}
                                {(formFields[section.sectionId]?.length != 0 && privileges?.MANAGE_FORM_FIELD?.includes(Privileges.MODIFY) && formtemplateStatus === 'IN_PROGRESS') &&
                                  <button onClick={() => onSaveButtonClick(section.sectionId)}>Save</button>}
                              </ul>
                            )
                          }
                        </Droppable>
                      </AccordionDetails>
                      {provided1.placeholder}
                    </Accordion>
                  )}
                </Draggable>

              )}
              {provided1.placeholder}
            </div>)}
        </Droppable>
      </DragDropContext>


      <CustomAlertDialog isOpen={openAlert.isAlert} title="Alert"
        message={openAlert.isField ? "Are you sure you want to delete this field?" : "Are you sure you want to delete this section?"}
        onCancel={() => setOpenAlert(false)}
        onClose={() => setOpenAlert(false)}
        onSubmit={() => {
          if (openAlert.isField) {
            deleteField(openAlert.id)
          } else {
            deleteSection(openAlert.id)
          }
        }}
        submitBtnName='Delete'
      />
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleActionMenuClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        {privileges?.MANAGE_FORM_FIELD?.includes(Privileges.MODIFY) &&
          <MenuItem onClick={() => {
            handleEditFormField()
            handleActionMenuClose()
          }
          }><MdOutlineModeEditOutline className={styles['cus_form_fields_edit_icon']} />Edit</MenuItem>}
        {privileges?.MANAGE_FORM_FIELD?.includes(Privileges.DELETE) &&
          <MenuItem onClick={() => {
            setOpenAlert({ isAlert: true, id: fieldData?.id, isField: true })
            handleActionMenuClose()
          }}><AiTwotoneDelete className={styles['cus_form_fields_edit_icon']} />Delete</MenuItem>}
      </Menu>
      <Menu
        id="basic-menu"
        anchorEl={openSectionMenu}
        open={Boolean(openSectionMenu)}
        onClose={() => setOpenSectionMenu(null)}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        {privileges?.MANAGE_FORM_FIELD?.includes(Privileges.MODIFY) &&
          <MenuItem onClick={() => {
            setOpenPopup({ isOpen: true, for: 'SECTION', isEdit: true })
            setOpenSectionMenu(null)
          }
          }><MdOutlineModeEditOutline className={styles['cus_form_fields_edit_icon']} />Edit</MenuItem>}
        {(!isRequiredSection(formSection.id) && privileges?.MANAGE_FORM_FIELD?.includes(Privileges.DELETE)) &&
          <MenuItem onClick={() => {
            setOpenAlert({ id: formSection.id, isAlert: true, isField: false })
            setOpenSectionMenu(null)
          }}><AiTwotoneDelete className={styles['cus_form_fields_edit_icon']} />Delete</MenuItem>}
      </Menu>

      <CustomDialog
        title="Add Custom Field"
        isOpen={openPopup.isOpen}
        onClose={() => setOpenPopup({ isOpen: false, for: openPopup.for, isEdit: false })}
        onCancel={() => {
          setOpenPopup({ isOpen: false, for: openPopup.for, isEdit: false });
          setFieldData(initialValue);
          setFieldErrors({});
          setFormSection({ id: '', name: '' })
        }}
        onSubmit={openPopup.for === 'SECTION' ? handleFormSectionSubmit : onSubmitForm}
      >
        {openPopup.for === 'SECTION' ?
          <div className={styles['add_form_section_form']} >
            <TextField
              error={fieldErrors['sectionName']}
              inputProps={{ maxLength: 200 }}
              helperText={fieldErrors['sectionName'] && fieldErrors['sectionName']}
              className={styles['form_text_field_theme']}
              value={formSection.name}
              onChange={(e) => setFormSection(prev => ({ ...prev, name: e.target.value }))}
              fullWidth label="Section Name" />
          </div>
          :
          <div className={styles['add_cus_field_form']} >
            <div className={styles['add_cus_field_part_1']}>
              <FormControl error={fieldErrors['section']} fullWidth data-testid="game-dropdown" className={styles['form_dropdown_input_theme']}>
                <InputLabel id="demo-simple-select-autowidth-label">Section</InputLabel>
                <Select
                  labelId="demo-simple-select-autowidth-label"
                  id="demo-simple-select-autowidth"
                  fullWidth
                  label="Section"
                  name='section'
                  value={fieldData.section || ''}
                  onChange={handleSetData}
                >
                  {
                    formSections?.map((fs, index) =>
                      <MenuItem sx={{ textTransform: 'capitalize' }} key={index} value={fs.id}>{fs?.title}</MenuItem>
                    )
                  }


                </Select>
                {
                  fieldErrors['section'] &&
                  <FormHelperText sx={{ color: 'red', m: 0 }}>{fieldErrors['section']}</FormHelperText>
                }
              </FormControl>
              <FormControl error={fieldErrors['fieldType']} fullWidth data-testid="game-dropdown" className={styles['form_dropdown_input_theme']}>
                <InputLabel id="demo-simple-select-autowidth-label">Field Type</InputLabel>
                <Select
                  labelId="demo-simple-select-autowidth-label"
                  id="demo-simple-select-autowidth"
                  fullWidth
                  label="Field Type"
                  name='fieldType'
                  sx={{ textTransform: 'capitalize' }}
                  value={fieldData.fieldType || ''}
                  onChange={handleSetData}
                >
                  {
                    inputTypeList.map((type, index) =>
                      <MenuItem sx={{ textTransform: 'capitalize' }} key={index} value={type}>{type}</MenuItem>
                    )
                  }


                </Select>
                {
                  fieldErrors['fieldType'] &&
                  <FormHelperText sx={{ color: 'red', m: 0 }}>{fieldErrors['fieldType']}</FormHelperText>
                }
              </FormControl>
            </div>
  
            <TextField
              error={fieldErrors['fieldName']}
              helperText={fieldErrors['fieldName'] && fieldErrors['fieldName']}
              className={styles['form_text_field_theme']}
              fullWidth
              label="Field Name" name='fieldName'
              value={fieldData.fieldName || ''}
              onChange={handleSetData} />

            <FormControl fullWidth data-testid="game-dropdown" className={styles['form_dropdown_input_theme']}>
              <InputLabel id="demo-simple-select-autowidth-label">Bind With</InputLabel>
              <Select
                labelId="demo-simple-select-autowidth-label"
                id="demo-simple-select-autowidth"
                fullWidth
                label="Bind With"
                name='bindWith'
                sx={{ textTransform: 'capitalize' }}
                value={fieldData.bindWith || ''}
                onChange={handleSetData}
              >
                {
                  PREDEFINED_FIELDS.map((data, index) =>
                    <MenuItem sx={{ textTransform: 'capitalize' }} key={index} value={data.key}>{data.label}</MenuItem>
                  )
                }
              </Select>

            </FormControl>

            {(fieldData.fieldType === 'radio' || fieldData.fieldType === 'dropdown') && <>
              {
                options?.map((op, index) =>
                  <div key={index} className={styles['add_option_container']}>
                    <TextField className={styles['form_text_field_theme']} fullWidth label={`Option ${index + 1}`} name='fieldName'
                      value={op}
                      onChange={(e) => handleFieldOptions(e.target.value, index)}
                      size='small'
                    />
                    <CgClose onClick={() => {
                      if (options.length > 1) {
                        setOptions(options.filter((o, idx) => idx !== index))
                      }
                    }} className={styles['close_option_icon']} />
                  </div>
                )
              }
              <GrFormAdd onClick={() => {
                setOptions([...options, ''])
              }} className={styles['add_option_icon']} />

            </>}

            <TextField className={styles['form_text_field_theme']} fullWidth label="Tooltip" name='tooltip'
              value={fieldData.tooltip || ''}
              onChange={handleSetData} />

            <div className={styles['form_field_switch']}>
              <CustomSwitch checked={fieldData.isRequired} onChange={(event) => handleSetData({ target: { name: 'isRequired', value: event.target.checked } })} />
              <p>Is Required For Registration?</p>
            </div>
          </div>}
      </CustomDialog>
    </div>
  )
}

export default FormFields